module.exports = __webpack_public_path__ + "img/744.1e41c749.jpg";